exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.taskStatusBall {\n  height: 10px;\n  width: 10px;\n  background-color: silver;\n  border-radius: 100%;\n  display: inline-block;\n}\n.taskStatusBall.active {\n    background-color: #6ac951;\n}\n.taskStatusBall.notActive {\n    background-color: #f16c64;\n}\n.scheduleTaskListStatus {\n  width: 1%;\n}\n.scheduleTaskListType {\n  width: 180px;\n}\n.scheduleTaskListRepetition {\n  width: 280px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-2757ba39","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/scheduleTasks/scheduleTasks.vue
// module id = 3057
// module chunks = 0